<template>
  <layout>
    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">运输船舶</font>
        </div>
      </div>
      <div class="headerB flex-between">
        <div class="flex-center-y">
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">平台注册<br />船舶数量</div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.pageCount || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">艘</div>
            </dt>
          </dl>

          <dl class="item" @click="$QHopen.url('/log?action=500', 95,95)" v-if="!$isblank(logTotast)">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>审核</p>
                <p class="flex-center-y">
                  <span>记录</span>
                </p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(logTotast.action_500 || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">次</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li>
          <Input size="small" v-model="searchMap.keyword" placeholder="船舶号牌/经营人手机" style="width: 250px" />
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="shipCode">
            <carLicense :license="row.shipCode" licenseType="200"></carLicense>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="capacity"> {{ row.capacity }}m³ </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="cancelstatue">
            <span v-if="row.cancelstatue == 100">未注销</span>
            <span v-if="row.cancelstatue == 200">已注销</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="expirestatus">
            <span v-if="row.expirestatus == 100">未过期</span>
            <span v-if="row.expirestatus == 200">已过期</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="teststatus">
            <span v-if="row.teststatus == 100">未检测</span>
            <span v-if="row.teststatus == 200">已检测</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="allQualificationsCount">
            <b style="font-size: 18px; color: #01aaed" v-if="row.allQualificationsCount > 0">{{ row.allQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.allQualificationsCount == 0">{{ row.allQualificationsCount }}</b>
            <span>件</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="invalidQualificationsCount">
            <b style="font-size: 18px; color: #ed4014" v-if="row.invalidQualificationsCount > 0">{{ row.invalidQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.invalidQualificationsCount == 0">{{ row.invalidQualificationsCount }}</b>
            <span>件</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="status">
            <Tag color="success" v-if="row.status == 100">已启用</Tag>
            <Tag color="error" v-if="row.status == 200">已停用</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <Button type="warning" size="small" @click="$refs.detailed.hiPop(row)">详情</Button>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <detailed ref="detailed" @success="getList();$getLogTotast()"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
export default {
  components: {
    detailed,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      pageThis: this,
      loading: false,
      selectedRows: [],
      total: {},
      columns: this.$colFilter([
        {
          title: "船舶号牌",
          key: "shipCode",
          width: 150,
          align: "center",
          slot: "shipCode",
        },
        {
          title: "平台号码",
          key: "name",
          width: 120,
          align: "center",
        },
        {
          title: "船舶载量",
          key: "capacity",
          width: 120,
          align: "center",
          slot: "capacity",
        },
        {
          title: "全部资质",
          width: 80,
          align: "center",
          slot: "allQualificationsCount",
        },
        {
          title: "异常资质",
          width: 80,
          align: "center",
          slot: "invalidQualificationsCount",
        },
        {
          title: "注销状态",
          key: "cancelstatue",
          width: 80,
          align: "center",
          slot: "cancelstatue",
        },
        {
          title: "过期状态",
          key: "expirestatus",
          width: 80,
          align: "center",
          slot: "expirestatus",
        },
        {
          title: "检验状态",
          key: "teststatus",
          width: 80,
          align: "center",
          slot: "teststatus",
        },
        {
          title: "船属企业",
          key: "owner",
          minWidth: 180,
          align: "center",
        },
        {
          title: "船舶登记号",
          key: "registrationNumber",
          width: 150,
          align: "center",
        },
        {
          title: "船检登记号",
          key: "inspectionRegistrationNumber",
          width: 150,
          align: "center",
        },
        {
          title: "经营人手机",
          key: "phoneNumber",
          width: 130,
          align: "center",
        },
        {
          title: "注册SIM号",
          key: "registerNumber",
          width: 130,
          align: "center",
        },
        {
          title: "经营许可证号码",
          key: "licenseNumber",
          width: 180,
          align: "center",
        },
        {
          title: "年审起始时间",
          key: "validityPeriodstart",
          width: 130,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.validityPeriodstart, "YYYY-MM-DD");
            return h("span", time);
          },
        },
        {
          title: "年审终止时间",
          key: "validityPeriodend",
          width: 130,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.validityPeriodend, "YYYY-MM-DD");
            return h("span", time);
          },
        },

        {
          title: "创建时间",
          key: "created",
          width: 135,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.created, "YYYY-MM-DD HH:mm");
            return h("span", time);
          },
        },

        {
          title: "启用状态",
          key: "status",
          width: 80,
          fixed: "right",
          align: "center",
          slot: "status",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 60,
          slot: "action",
          align: "center",
        },
      ]),
      searchMap: {
        keyword: "",
        status: 100,
        pageNo: 1,
        pageSize: 25,
      },
      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
      total: "",
      logTotast:{},
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    this.getList();

    //审核日志
    this.$getLogTotast(); 
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      var parameter = this.searchMap;
      var https = {
        type: "isPagelist",
        api: this.$api.getShipList,
        parameter: parameter,
      };
      this.$httpsApi(https, function (res) {
        that.total = res.count;
        that.dataLoading = true;
      });
    },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search(status) {
      if (!this.$isblank(status)) {
        this.searchMap.status = status;
      }
      this.searchMap.pageNo = 1;
      this.getList();
    },
  },
};
</script>
<style>
.pageSearch {
  width: 100% !important;
  left: 0;
}
.pageContent {
  width: 100% !important;
  left: 0;
}
.QHPage {
  left: 0;
}
</style>
